<template>
<div>
  <div id="bottom">
    <div class="content">
      <dl class="official">
        <dt><img src="../../static/image/Bottom/logo2.png" /></dt>
          <dd class="first">{{ $t('lang.bottom.tip1') }}</dd>
          <dd>{{ $t('lang.bottom.tip2') }}</dd>
          <dd class="wechat_body" @click="openCode">
            <img src="../../static/image/Bottom/wechat.png" class="wechat" />
            <img src="../../static/image/Bottom/jiantou.png" class="jiantou"/>
            <span>{{ $t('lang.bottom.tip3') }}</span>
          </dd>
      </dl>
      <dl class="product_way">
        <dt>{{ $t('lang.bottom.tip4') }}</dt>
          <dd class="first">{{ $t('lang.bottom.tip5') }}</dd>
          <dd>{{ $t('lang.bottom.tip6') }}</dd>
          <dd>BUY NOW PAY LATER</dd>
          <dd>{{ $t('lang.bottom.tip7') }}</dd>
          <dd>{{ $t('lang.bottom.tip8') }}</dd>
      </dl>

      <dl class="contact_US">
        <dt>{{ $t('lang.bottom.tip9') }}</dt>
        <div>
          <dd>
            <div>
              <img src="../../static/image/Bottom/img1.png" />
              <span>{{ $t('lang.bottom.tip10') }}</span>
            </div>
            <p>+86 18601300022</p>
          </dd>
          <dd>
            <div>
              <img src="../../static/image/Bottom/img2.png" />
              <span>{{ $t('lang.bottom.tip11') }}</span>
            </div>
            <p>hq@heat.com</p>
          </dd>
          <dd>
            <div>
              <img src="../../static/image/Bottom/img3.png" />
              <span>{{ $t('lang.bottom.tip12') }}</span>
            </div>
            <p>http://www.hqneat.com</p>
          </dd>
          <dd>
            <div>
              <img src="../../static/image/Bottom/img4.png" />
              <span>{{ $t('lang.bottom.tip13') }}</span>
            </div>
            <p>广东省深圳市南山区西丽街道石鼓路深圳万科云城国际创新谷3期7栋C座502</p>
          <div style="margin-top: 20px;">
            <div>
              <img src="../../static/image/Bottom/img4.png" />
              <span>{{ $t('lang.bottom.tip16') }}</span>
            </div>
            <p>陕西省西安市高新区丈八北路89号龙城铭园1期5幢502室</p>
          </div>
          </dd>
          <dd>
            <div>
              <img src="../../static/image/Bottom/img4.png" />
              <span>{{ $t('lang.bottom.tip14') }}</span>
            </div>
            <p>香港九龙旺角弥顿道678华侨商业中心15C</p>
          </dd>
          <dd>
            <div>
              <img src="../../static/image/Bottom/img4.png" />
              <span>{{ $t('lang.bottom.tip15') }}</span>
            </div>
            <p>河北省张家口市盛华东大街31号</p>
          </dd>
        </div>
      </dl>
    </div>

    <!-- <div class="top">
      <div class="top-f">
        <div class="top-title">深圳市泓齐网络科技有限公司</div>
        <div class="top-bottom">
          <div class="top-left">
            <p>公司电话：+86-0755-26605509</p>
            <p>公司邮箱：hq@hqneat.com</p>
            <p>公司网址：http://www.hqneat.com</p>
            <p>
              公司地址：广东省深圳市南山区西丽街道石鼓路深圳万科云城国际创新谷3期7栋C座502
            </p>
          </div>
          <div class="top-right">
            <img src="../../static/image/HellowWorld/erCode.jpg" />
            <p>微信扫码关注</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      Copyright2017-2018 深圳市泓齐网络科技有限公司
      <span
        onclick="window.open('https://beian.miit.gov.cn/')"
        style="cursor: pointer;"
        >粤ICP备18002099号-1</span
      >
    </div> -->
  </div>
  <el-dialog
      :visible.sync="dialogVisible"
      width="29.3%"
      >
      <div class="left">
        <img class="company_logo" style="text-align: left;" src="../../static/image/Bottom/logo2.png" />
        <img class="code" src="../../static/image/HellowWorld/erweima.jpg" />
        <h5>{{ $t('lang.HellowWorld.wxsm1') }}</h5>
        <p>{{ $t('lang.HellowWorld.yljr') }}</p>
      </div>
    </el-dialog>
</div>
</template>
<script>
export default {
  name: 'GoTop',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    openCode () {
      this.dialogVisible = true
    }
  }
}
</script>
<style scoped>
#bottom {
  height: 630px;
  width: 100%;
  background: url("./static/image/Bottom/bottom_ground.png") no-repeat;
  background-size: 100% 100%;
  text-align: left;
}

#bottom .content{
  padding: 102px 0 0 163px;
  display: flex;
}

#bottom .content dl{
  margin-left: 112px;
}

#bottom .content dt{
  font-family: 苹方;
  font-size: 24px;
  font-weight: 900;
  color: #fff;
}

#bottom .content dd{
  margin-top: 16px;
  font-family: 苹方;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.3px;
  color: #fff;
  opacity: .6;
}

#bottom .content .first{
  margin-top: 41px;
}

#bottom .content .wechat_body{
  margin-top: 48px;
  display: flex;
  align-items: center;
  opacity: 1!important;
  cursor: pointer;
}

.wechat_body .wechat{
  width: 32px;
  height: 32px;
}

.wechat_body .jiantou{
  margin-left: 12.5px;
  width: 7px;
  height: 6px;
}

.wechat_body span{
  margin-left: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #B2B7C4;
}

.official{
  width: 300px;
}

.official dt img{
  width: 152px;
  height: 32px;
}

.product_way{
  text-align: left;
}

#bottom .content .contact_US{
  width: 776px;
  margin-left: 239px;
  font-size: 16px;
  color: #fff;
}

#bottom .content .contact_US > div{
  width: 100%;
  margin-top: 41px;
}

#bottom .content .contact_US div dd{
  float: left;
  width: 232px;
  margin: 0 0 40px 35px;
}

#bottom .content .contact_US div dd:nth-child(1){
  margin-left: 0;
}

#bottom .content .contact_US div dd:nth-child(4){
  margin-left: 0;
}

#bottom .content .contact_US div img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
#bottom .content .contact_US div span {
  font-weight: 500;
}
#bottom .content .contact_US p {
  margin-top: 8px;
  font-weight: 400;
  margin-left: 17px;
}

.top {
  height: 344px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.top-f {
  width: 1200px;
  height: auto;
  text-align: left;
}
.top-title {
  font-size: 18px;
  padding-bottom: 12px;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.top-bottom {
  display: flex;
  font-size: 14px;
}
.top-left {
  flex: 1 1 auto;
}
.top-left p {
  margin-top: 20px;
}
.top-right {
  width: 90px;
  text-align: center;
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}
.top-right img {
  width: 90px;
  height: 90px;
  margin-bottom: 10px;
}
.top-right p {
  font-size: 14px;
}
.bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  /* line-height: 56px;
  text-align: center; */
  font-weight: 400;
  color: #fff;
  font-size: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
}
/deep/ .el-dialog__body{
  padding: 0;
}
/deep/ .el-dialog__header{
  display: none;
}
.left{
  width: 600px;
  height: 600px;
  /* height: 600px; */
  background: url("./static/image/HellowWorld/popup.png") no-repeat;
  background-size: 100% 101%;
}
.left .company_logo{
  text-align: left;
  width: 152px;
  height: 32px;
  margin: 71px 0 0 -300px;
}
.left .code{
  display: block;
  margin: 120px auto 0;
  width: 154px;
  height: 154px;
}
.left h5{
  margin-top: 24px;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  text-align: center;
}
.left p{
  margin-top: 123px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 8px;
  line-height: 0px;
  color: #fff;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/common/Bottom.vue